import localforage from 'localforage';

export default {
  init: () => {
    localforage.config({
      name: 'At And v1'
    });
  },

  setRecentPresentations: (recentPresentations) => {
    localforage.setItem('recentPresentations', recentPresentations).catch((err) => {
      console.log(err);
    });
  },

  getRecentPresentations: () => localforage.getItem('recentPresentations'),

  setReturningUserFlag: () => {
    localforage.setItem('returningUser', true).catch((err) => {
      console.log(err);
    });
  },

  getReturningUserFlag: () => localforage.getItem('returningUser'),

  setCurrentPresentation: (presentationId, presentation) => {
    const currentPresentation = Object.assign(
      { presentationId },
      presentation
    );
    localforage.setItem('currentPresentation', currentPresentation).catch((err) => {
      console.log(err);
    });
  },

  getCurrentPresentation: () => localforage.getItem('currentPresentation'),

  removeCurrentPresentation: () => {
    localforage.removeItem('currentPresentation').catch((err) => {
      console.log(err);
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/offlineStoreApi.js